import * as ApiManager from './_manager';
import store from '@/store';

export const monetization = {
  // Pricing
  createGroupPricing: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/createGroupPricing`,
      payload
    );
  },
  updateGroupPricing: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/${payload.id}/updateGroupPricing`,
      payload
    );
  },
  listPricing: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/listCompanyPricing`,
      payload
    );
  },
  getPricing: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/getPricing`,
      payload
    );
  },
  getPricingScreenings: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/${payload.pricing_id}/getPricingScreenings`,
      payload
    );
  },
  // Purchases
  listPurchases: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/listPurchases`,
      payload
    );
  },
  getPurchase: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/getPurchase`,
      payload
    );
  },
  exportAllPurchases: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/exportAllPurchases`,
      payload
    );
  },
  listPayouts: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/listPayouts`,
      payload
    );
  },
  addPayout: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/addPayout`,
      payload
    );
  },
  removePayout: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/removePayout`,
      payload
    );
  },
  updatePayoutRequest: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/monetization/updatePayoutRequest`,
      payload
    );
  },
};
